module.exports = __webpack_public_path__ + "img/hr-stack-inserter-hand-open-shadow.451d4e8d.png";